module.exports = __webpack_public_path__ + "media/03 melt.e69ac802.mp3";